export default __webpack_public_path__ + "d50f5cfdb9e5ca54bf6f5ce1486f86d7.svg";